import { useDispatch } from 'react-redux'
import { showNotification } from 'shared/redux/slice/notificationSlice'
import { downloadBlob } from 'shared/utils/downloadBlob'

const useDownloadFile = () => {
    const dispatch = useDispatch()

    const showError = (message: string) => {
        dispatch(
            showNotification({
                message: 'Не удалось скачать файл',
                type: 'error',
                errMessage: message,
            }),
        )
    }

    const downloadFile = async (fileUrl: string, fileName: string) => {
        try {
            const response = await fetch(fileUrl)
            if (!response.ok) {
                dispatch(
                    showNotification({
                        message: 'Не удалось скачать файл',
                        type: 'error',
                    }),
                )
            }

            const blob = await response.blob()
            return downloadBlob(blob, fileName)
        } catch (error: unknown) {
            showError((error as Error)?.message)
        }
    }

    const downloadFileByBlob = async (blob: Blob, fileName: string) => {
        try {
            return downloadBlob(blob, fileName)
        } catch (error: any) {
            showError((error as Error)?.message)
        }
    }

    return {
        downloadFile,
        downloadFileByBlob,
    }
}

export default useDownloadFile
